<template>
    <div>
        <!-- <div id="main"></div> -->
        <vue-echarts :option="option" ref="chart" class="chart" autoResize />
    </div>
</template>

<script>
import { VueEcharts } from "vue3-echarts";

export default {
    name: 'doughnut',
    data() {
        return {
        }
    },
    components: {
        VueEcharts,
    },
    props: {
        houseHoldProb: Object,
        prefixAmount: String,
    },
    methods: {
        globalNumDecFixed(num, dec_amount) {
            var new_num = Number(num);
            if (!(num % 1)) {
                dec_amount = 0;
            }
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: dec_amount,
            }).format(new_num.toFixed(dec_amount));
        },
        millionShortNum(num) {
            if (num >= 1000000000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    2
                );
            }
            if (num >= 1000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    2
                );
            }
            if (num >= 1000000000000) {
                return this.globalNumDecFixed((num / 1000000000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 2);
            }
            if (num >= 1000000) {
                return this.globalNumDecFixed((num / 1000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 2);
            }
            return this.globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 2);
        },
        millionShortString(num) {
            if (num >= 1000000000000000000000000) {
                return "ล้านล้านล้านล้าน";
            }
            if (num >= 1000000000000000000) {
                return "ล้านล้านล้าน";
            }
            if (num >= 1000000000000) {
                return "ล้านล้าน";
            }
            if (num >= 1000000) {
                return "ล้าน";
            }
            return '';
        }
    },
    mounted() {
        setTimeout(function () {
            this.$nextTick(() => {
                this.$refs.chart.setOption(this.option);
            })
        }.bind(this), 350)
    },
    watch: {
        houseHoldProb(newData, oldData) {
            this.$nextTick(() => {
                this.$refs.chart.setOption({
                    data: [
                        { value: newData.total.prob_health, name: 'สุขภาพ' },
                        { value: newData.total.prob_family, name: 'ความเป็นอยู่' },
                        { value: newData.total.prob_education, name: 'การศึกษา' },
                        { value: newData.total.prob_occupation, name: 'รายได้' },
                        { value: newData.total.prob_accessibility, name: 'การเข้าถึงบริการรัฐ' },
                    ]
                }

                );
            })
        }
    },
    computed: {
        option() {
            return {
                tooltip: {
                    trigger: 'item',
                    confine: 'true',
                    textStyle: {
                        fontFamily: 'kanit',
                        fontWeight: '400',
                        color: '#1d4481'
                    },
                    backgroundColor: '#f3f6f9',
                    borderColor: 'none',
                    valueFormatter: (value) => this.globalNumDecFixed(value) + ' ' + this.prefixAmount
                },
                legend: {
                    show: false,
                },
                textStyle: {
                    fontFamily: 'kanit',
                    fontWeight: 'normal'
                },
                series: [
                    {
                        name: {
                            show: false
                        },
                        type: 'pie',
                        radius: ['65%', '90%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderColor: '#e0f7f7',
                            borderWidth: 5,
                        },
                        label: {
                            show: true,
                            position: 'center',
                            formatter: '\n' + this.prefixAmount + 'ที่ประสบปัญหา \n\n {c|' + this.millionShortNum(this.houseHoldProb.total.total_prob) + '} \n\n' + this.millionShortString(this.houseHoldProb.total.total_prob) + this.prefixAmount,
                            rich: {
                                c: {
                                    fontSize: 25
                                }
                            },
                            textStyle: {
                                color: '#1d4481'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        color: ["#f8a436",
                            "#f68b96",
                            "#7bc573",
                            "#76c9fa",
                            "#a984fa"],
                        data: [
                            { value: this.houseHoldProb.total.prob_health, name: 'สุขภาพ' },
                            { value: this.houseHoldProb.total.prob_family, name: 'ความเป็นอยู่' },
                            { value: this.houseHoldProb.total.prob_education, name: 'การศึกษา' },
                            { value: this.houseHoldProb.total.prob_occupation, name: 'รายได้' },
                            { value: this.houseHoldProb.total.prob_accessibility, name: 'การเข้าถึงบริการรัฐ' },
                        ]
                    }
                ]
            }
        },
    },
};
</script>

<style scoped>
.chart {
    top: 0px;
    max-height: 250px;
    height: 250px;
}

@media screen and (max-width: 1199.8px) {
    .chart {
        max-height: 230px;
        height: 230px;
    }
}
</style>
